<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  beforeMount() {
    localStorage.setItem("localModel", "new");
    // localStorage.setItem("userOpenid", "OW8d5Awq1ZSvcNhMoHpR9K-BgnM");
    // localStorage.setItem("userOpenid", "");
    localStorage.setItem("fireFox", this.checkBrowser());
    
  },
  /**
   *
   */
  methods: {
    isFirefox() {
      // 使用正则表达式来检测Firefox
      return /Firefox/i.test(navigator.userAgent);
    },

    checkBrowser() {
      // 如果浏览器是Firefox，则返回false；否则返回true
      return !this.isFirefox(); // 注意这里的逻辑取反
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 0px;
  /* zoom: .95; */
}
/* global.css 或其他全局样式文件 */
.important_red { /* 可以简化选择器，因为是全局的 */
  color: #f04848 !important;
}

* {
  margin: 0;
  padding: 0;
}

ul,
li {
  list-style: none;
}

a {
  text-decoration: none;
}

img {
  vertical-align: bottom;
  max-width: 100%;
}

.flex {
  display: flex;
}

.flex_wrap {
  display: flex;
  flex-wrap: wrap;
}

.flex_middle {
  display: flex;
  align-items: center;
  justify-content: center;
}

.cursor {
  cursor: pointer;
}

.el-popover.popper_time {
  font-size: 16px;
}

.highlight-wrap {
  color: #000;
  background-color: #fdf302;
}
/* .highlight-wrap1 {
  color: #000;
  background-color: #13f6ff;
}
.highlight-wrap2 {
  color: #000;
  background-color: #fdf302;
} */
.highlight-mengshou-wrap.highlight-wrap2 {
  color: #000;
  background-color: #f1e903;
  border-radius: 5px;
  padding: 0 5px;
  box-shadow: 1px 1px 3px #e1e1e1;
}
.highlight-mengshou-wrap.highlight-wrap1 {
  color: #000;
  background-color: #06e7ef;
  border-radius: 5px;
  padding: 0 5px;
  box-shadow: 1px 1px 3px #e1e1e1;
}
.new-class {
  position: relative;
}

.isItalic {
  font-style: italic;
}

.new-class::after {
  z-index: 40;
  display: block;
  width: 9px;
  height: 9px;
  position: absolute;
  bottom: 2em;
  right: 0;
  content: url("https://jingyouxue-student-web.oss-cn-hangzhou.aliyuncs.com/content/iconNotes.png");
}

:root {
  --main0077: #0077ed;
  --main99: #99c8f8;
}

.text_input .el-textarea__inner {
  color: #000;
  font-weight: normal;
  font-family: "arial", "微软雅黑", generic-family;
}
</style>



// WEBPACK FOOTER //
// src/App.vue